<template>
	<div>
		<h1>People</h1>

		<InputTextSingleLineMulti
			question="Who are the authors in the study?"
			v-model="$tera.project.author"
			placeholder="e.g. Justin Clark"
		/>

		<InputTextSingleLineMulti
			question="Who else helped with the study? (Acknowledgements)"
			v-model="$tera.project.acknowledgements"
			placeholder="e.g. Justin Clark"
		/>
	</div>
</template>
<script>
import InputTextSingleLineMulti from "@/components/InputTextSingleLineMulti.vue";
//import { defaults } from "./settingdefaults";

export default {
	name: "ViewTitlePagePeople",

	components: {
		InputTextSingleLineMulti
	}
	/*data() {
		return {
			authors: Array,
			acknowledgements: Array
		};
	},
	async mounted() {
		if (this.$tera.project.author == undefined) {
			await this.$tera
				.setProjectStateDefaults("author", defaults.titlepage.authors)
				.then(response => {
					if (response) {
						this.authors = response;
						console.log("author response:" + response);
					}
				});
		} else {
			this.authors = this.$tera.project.author;
		}

		if (this.$tera.project.acknowledgements == undefined) {
			await this.$tera
				.setProjectStateDefaults(
					"acknowledgements",
					defaults.titlepage.acknowledgements
				)
				.then(response => {
					if (response) {
						this.acknowledgements = response;
					}
				});
		} else {
			this.acknowledgements = this.$tera.project.acknowledgements;
		}
	}*/
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
